import { ClientPayloadProps } from "modules/video/video_detail/store/actionType";
import { FeaturedAdsProps, stateStatusType } from './actionType';

export interface FetchFeaturedAdsState {
  isLoading: boolean;
  error: string | null;
  featuredAds: FeaturedAdsProps[] | [];
  featuredAdsVideo: ClientPayloadProps | null;
  status: stateStatusType | null;
}
export interface GenericFeaturedAdsStateProps {
  isLoading: boolean;
  status: stateStatusType | null;
  error: string | null;
}

export const initialFeaturedAdsState: FetchFeaturedAdsState = {
  isLoading: false,
  error: null,
  featuredAds: [],
  featuredAdsVideo: null,
  status: null,
};
export const initialGenericFeaturedAdsState: GenericFeaturedAdsStateProps = {
  isLoading: false,
  error: null,
  status: null,
};

export interface FeaturedAdsState {
  featuredAdsState: FetchFeaturedAdsState;
  genericFeaturedAdsState: GenericFeaturedAdsStateProps;
}

export const initialState: FeaturedAdsState = {
  featuredAdsState: initialFeaturedAdsState,
  genericFeaturedAdsState: initialGenericFeaturedAdsState,
};
